import { CameraService } from './camera.service';
import { CoreService } from './core.service';
import { SimplePolygonMapEntity } from './simple-polygon-map-entity.service';
import { Color } from 'cesium';
import * as Cesium from 'cesium';
import { BaseEntityAttribute } from './base-entity-attribute';
import { CoresService } from './cores.service';
import { WindowService } from './window.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataContextService } from './data-context.service';
import { TimelineService } from './timeline.service';
import * as THREE from 'three';
import { ThreeIntegrationService } from './three-js-building.service';
export class PerimeterMapEntity extends SimplePolygonMapEntity {
  static readonly PERIMETER_USER_COUNT_STATUS_SOME_USERS = 'PERIMETER_USER_COUNT_STATUS_SOME_USERS';
  static readonly PERIMETER_USER_COUNT_STATUS_NO_USERS = 'PERIMETER_USER_COUNT_STATUS_NO_USERS';
  static readonly PERIMETER_SAFETY_STATUS_SAFE = 'PERIMETER_SAFETY_STATUS_SAFE';
  static readonly PERIMETER_SAFETY_STATUS_UNSAFE = 'PERIMETER_SAFETY_STATUS_UNSAFE';
  static readonly PERIMETER_SAFETY_STATUS_UNKNOWN = 'PERIMETER_SAFETY_STATUS_UNKNOWN';

  override id: string;
  transparency = 0.3;
  arcAngelId: any;
  floorId: any;
  orgId: any;
  label: string;
  isPartOfBuilding = false;
  cameraEntities: any[] = [];
  clusters: any[] = [];
  beacons: Record<string, any> = {};
  sensorIds: Record<string, any> = {};
  devices: any[] = [];
  trackingDevices: Record<string, any> = {};
  dimmed = false;
  listOfUnknownUsers: any[] = [];
  listOfUnsafeUsers: any[] = [];
  listOfSafeUsers: any[] = [];
  listOfFR: any[] = [];
  perimeterUserCountStatus = 'PERIMETER_USER_COUNT_STATUS_SOME_USERS';
  perimeterSafetyStatus = 'PERIMETER_USER_COUNT_STATUS_SOME_USERS';
  perimeterSafetyStatusLast = 'PERIMETER_USER_COUNT_STATUS_SOME_USERS'
  perimeterType: any;
  ancestors: any;
  parentPerimeterId?: any;
  override isVisibleInOverlappingEntitiesUI = false;
  PERIMETER_USER_COUNT_STATUS_SOME_USERS = 'PERIMETER_USER_COUNT_STATUS_SOME_USERS';
  PERIMETER_USER_COUNT_STATUS_NO_USERS = 'PERIMETER_USER_COUNT_STATUS_NO_USERS';
  PERIMETER_SAFETY_STATUS_SAFE = 'PERIMETER_SAFETY_STATUS_SAFE';
  PERIMETER_SAFETY_STATUS_UNSAFE = 'PERIMETER_SAFETY_STATUS_UNSAFE';
  PERIMETER_SAFETY_STATUS_UNKNOWN = 'PERIMETER_SAFETY_STATUS_UNKNOWN';
  constructor(
    id: any,
    label: string,
    coordinates: any,
    date: any,
    orgId: any,
    elevation: any,
    height: any,
    floorId: any,
    perimeterType: any,
    ancestors: any,
    private $log: any,
    private camera: CameraService,
    private perimeterAttribute: any,
    private cores: CoresService,
    coreService: CoreService,
    windowService: WindowService,
    dataContext: DataContextService,
    modalService: NgbModal,
    timelineService: TimelineService
  ) {
    super('', '', camera, coreService, windowService, dataContext, modalService, timelineService);
    this.id = 'arc-angel-' + id;
    this.arcAngelId = id;
    this.floorId = floorId;
    this.orgId = orgId;
    this.label = label;
    this.perimeterType = perimeterType;
    this.ancestors = ancestors;

    const isCampus = perimeterType === 'CAMPUS';
    const color = isCampus
      ? Cesium.Color.fromCssColorString('#0088ff').withAlpha(0.18)
      : Cesium.Color.fromAlpha(Cesium.Color.LIGHTGRAY, this.transparency);

    this.init(
      label,
      'ArcAngel//Perimeters',
      coordinates,
      elevation,
      height,
      color
    );

    this.setTimestamp(date);
    this.setShowInLayersUI(false);
    const outlineColor = isCampus
      ? Cesium.Color.fromCssColorString('#0088ff')
      : Cesium.Color.BLACK.withAlpha(this.transparency + 0.1);
    this.setOutline(outlineColor);
    this.setShowOutline(true);
    this.setOutlineWidth(isCampus ? 3.5 : 1.0);
    this.removeDeleteCommand();
    this.removeShowHideCommand();
    this.removeTimelineCommand();
    this.removeTrackCommand();
    this.devices = [];
    this.addAttribute(new PerimeterAttribute(this.id));
    this.isVisibleInOverlappingEntitiesUI = false;
  }

  getArcAngelId() { return this.arcAngelId; }
  getParentPerimeterId() { return this.parentPerimeterId; }
  setParentPerimeterId(parentPerimeterId: any) { this.parentPerimeterId = parentPerimeterId; }
  getOrgId() { return this.orgId; }
  setOrgId(orgId: any) { this.orgId = orgId; }
  setLabel(label: string) { this.label = label; this.name = label; }
  getIsPartOfBuilding() { return this.isPartOfBuilding; }
  setIsPartOfBuilding(partOfBuilding: boolean) { this.isPartOfBuilding = partOfBuilding; }
  setSensorIds(sensorIds: any) { this.sensorIds = sensorIds; }
  getSensorIds() { return this.sensorIds; }
  addCamera(cameraEntity: any) { this.cameraEntities.push(cameraEntity); cameraEntity.setFloor(this); }
  getCameras() { return this.cameraEntities; }
  addBeacon(beacon: any) { this.beacons[beacon.id] = beacon; }
  setBeacons(beacons: any[]) {
    this.beacons = {};
    if (beacons && beacons.length > 0) {
      beacons.forEach((beacon, index) => {
        if (beacon && beacon.id) {
          this.beacons[beacon.id] = beacon;
        }
      });
    }
  }
  getBeacons() { return this.beacons; }
  addTrackingDevice(device: any) { this.trackingDevices[device.id] = device; }
  removeTrackingDevice(device: any) { this.$log.debug('removing device: ' + device.id); delete this.trackingDevices[device.id]; }
  clearDevices() {
    this.devices = [];
    this.listOfUnsafeUsers = [];
    this.listOfUnknownUsers = [];
    this.listOfSafeUsers = [];
    this.listOfFR = [];
    this.perimeterUserCountStatus = this.PERIMETER_USER_COUNT_STATUS_NO_USERS;
    // this.setMaterialFromStatus();
  }
  public initPerimeter(
    id: string,
    label: string,
    coordinates: any,
    date: string,
    orgId: string,
    elevation: number,
    height: number,
    floorId: string | null,
    perimeterType: string,
    ancestors: any
  ): void {
    this.arcAngelId = id;
    this.id = 'arc-angel-' + id;
    this.floorId = floorId;
    this.orgId = orgId;
    this.label = label;
    this.perimeterType = perimeterType;
    this.ancestors = ancestors;

    const isCampus = perimeterType === 'CAMPUS';
    const color = isCampus
      ? Color.fromCssColorString('#0088ff').withAlpha(0.18)
      : Color.fromAlpha(Color.LIGHTGRAY, this.transparency);

    this.init(
      label,
      'ArcAngel//Perimeters',
      coordinates,
      elevation,
      height,
      color
    );

    this.setTimestamp(date);
    this.setShowInLayersUI(false);
    const outlineColor = isCampus
      ? Color.fromCssColorString('#0088ff')
      : Color.BLACK.withAlpha(this.transparency + 0.3);
    this.setOutline(outlineColor);
    this.setShowOutline(true);
    this.setOutlineWidth(isCampus ? 3.5 : 1.0);

    this.removeDeleteCommand();
    this.removeShowHideCommand();
    this.removeTimelineCommand();
    this.removeTrackCommand();

    this.addAttribute(new PerimeterAttribute(this.id));
    this.isVisibleInOverlappingEntitiesUI = false;
  }
  setDevices(devices: any[], timestamp: any, skipBeaconsCheck: boolean) {
    let localDevices: any[] = [];
    this.listOfUnsafeUsers = [];
    this.listOfUnknownUsers = [];
    this.listOfSafeUsers = [];
    this.listOfFR = [];
    let perimeterUserCountStatus = '';
    let perimeterSafetyStatus = '';
    let devicesToUse = devices || this.devices;
    devicesToUse.forEach(device => {
      let closestBeacon;
      if (device) closestBeacon = device.getClosestBeacon(timestamp);
      if (device && (skipBeaconsCheck || (closestBeacon !== undefined))) {
        device.setCurrentAltitude(this.getHeight());
        localDevices.push(device);
        if (device.isUnSafe(timestamp)) {
          perimeterSafetyStatus = '';
          this.listOfUnsafeUsers.push(device);
        } else if (device.isUnKnown(timestamp)) {
          if (perimeterSafetyStatus === this.PERIMETER_SAFETY_STATUS_SAFE) {
            perimeterSafetyStatus = this.PERIMETER_SAFETY_STATUS_UNKNOWN;
          }
          this.listOfUnknownUsers.push(device);
        } else {
          this.listOfSafeUsers.push(device);
        }
        if (device.isFirstResponder()) {
          this.listOfFR.push(device);
        }
      }
    });
    if (localDevices.length > 0) {
      perimeterUserCountStatus = this.PERIMETER_USER_COUNT_STATUS_SOME_USERS;
    }
    if (this.perimeterUserCountStatus !== perimeterUserCountStatus || this.perimeterSafetyStatus !== perimeterSafetyStatus) {
      this.perimeterUserCountStatus = perimeterUserCountStatus;
      this.perimeterSafetyStatus = perimeterSafetyStatus;
      // this.setMaterialFromStatus();
    }
  }
  containsDevice(device: any, timestamp: any) {
    return device.getClosestBeacon(timestamp) !== undefined && device.getClosestBeacon(timestamp) in this.beacons;
  }
  getNumberOfUnSafeUsers() { return this.listOfUnsafeUsers.length + Object.keys(this.trackingDevices).length; }
  getNumberOfUnknownUsers() { return this.listOfUnknownUsers.length; }
  getNumberOfSafeUsers() { return this.listOfSafeUsers.length; }
  getNumberOfFirstResponders() { return this.listOfFR.length; }
  getNumberOfDevices() { return this.devices.length; }
  getListOfUnSafeUsers() {
    if (this.trackingDevices && Object.keys(this.trackingDevices).length > 0) {
      return [...this.listOfUnsafeUsers, ...Object.values(this.trackingDevices)];
    }
    return this.listOfUnsafeUsers;
  }
  getListOfUnknownUsers() { return this.listOfUnknownUsers; }
  getListOfSafeUsers() { return this.listOfSafeUsers; }
  getListOfFirstResponders() { return this.listOfFR; }
  getListDevices() { return this.devices; }
  getTrackingDevices() { return this.trackingDevices; }
  override hide() {
    super.hide();
    this.cameraEntities.forEach(c => c.hide());
    this.clusters.forEach(c => c.hide());

    // Remove datasource when hiding
    if (this.cesiumEntity && this.cesiumEntity.dataSource && this.cores.getViewer()) {
      this.cores.getViewer().dataSources.remove(this.cesiumEntity.dataSource);
    }
  }
  override show(showFloorEntities?: boolean) {
    super.show();
    if (showFloorEntities) {
      this.cameraEntities.forEach(c => c.show());
      this.clusters.forEach(c => c.show());
    }
    // this.setMaterialFromStatus();
  }
  dim() { if (!this.dimmed) this.dimmed = true; }
  undim() { if (this.dimmed) this.dimmed = false; }
  isPerimeterSafe() { return this.perimeterSafetyStatus === this.PERIMETER_SAFETY_STATUS_SAFE; }
  isPerimeterUnSafe() { return this.perimeterSafetyStatus === this.PERIMETER_SAFETY_STATUS_UNSAFE; }
  isPerimeterUnKnown() { return this.perimeterSafetyStatus === this.PERIMETER_SAFETY_STATUS_UNKNOWN; }
  restoreTransparency() {
    this.transparency = 0.1;
    this.setOutline(Cesium.Color.BLACK.withAlpha(this.transparency + 0.1));
    // this.setMaterialFromStatus();
  }
  increaseTransparency() {
    this.transparency -= 0.05;
    this.setOutline(Cesium.Color.BLACK.withAlpha(this.transparency + 0.1));
    // this.setMaterialFromStatus();
  }
  isVirtualizedVisible = true;
  static batchLoadGeoJson(entities: PerimeterMapEntity[], coreService: CoreService) {
    const viewer = coreService.getViewer();
    if (!viewer) return;
    const geoJsonFeatures: Array<{
      type: string;
      geometry: { type: string; coordinates: any[] };
      properties: { [key: string]: any }
    }> = [];
    entities.forEach(entity => {
      if (!entity.isVirtualizedVisible) return;
      const coordinates = entity.getCoordinates();
      if (coordinates && coordinates.length > 0) {
        const geoJsonCoords = coordinates.map(coord => [coord[1], coord[0]]);
        if (geoJsonCoords[0][0] !== geoJsonCoords[geoJsonCoords.length - 1][0] || geoJsonCoords[0][1] !== geoJsonCoords[geoJsonCoords.length - 1][1]) {
          geoJsonCoords.push(geoJsonCoords[0]);
        }
        geoJsonFeatures.push({
          type: 'Feature',
          geometry: { type: 'Polygon', coordinates: [geoJsonCoords] },
          properties: {
            name: entity.label,
            roomId: entity.arcAngelId,
            fillColor: entity.getFillColorHex(),
            strokeColor: entity.getStrokeColorHex(),
            altitude: entity.getAltitude(),
            height: entity.getHeight()
          }
        });
      }
    });
    if (geoJsonFeatures.length === 0) return;
    const geoJson = { type: 'FeatureCollection', features: geoJsonFeatures };
    Cesium.GeoJsonDataSource.load(geoJson, {
      stroke: Cesium.Color.BLACK,
      fill: Cesium.Color.LIGHTGRAY,
      strokeWidth: 0.5,
      clampToGround: false
    }).then((dataSource: any) => {
      viewer.dataSources.add(dataSource);
      dataSource.entities.values.forEach((entity: any) => {
        const props = entity.properties;
        if (entity.polygon && props) {
          entity.polygon.height = props.altitude || 0;
          entity.polygon.extrudedHeight = props.height || 1.0;
          // Fix: Set Cesium.Color as material for fill
          const fillColor = Cesium.Color.fromCssColorString(props.fillColor || '#cccccc').withAlpha(0.7);
          entity.polygon.material = fillColor;
          entity.polygon.outlineColor = Cesium.Color.fromCssColorString(props.strokeColor || '#000000');
          entity.polygon.show = true;
          entity.show = true;
        }
      });
    });
  }

  // Helper to get fill color as hex string
  getFillColorHex() {
    if (this.perimeterUserCountStatus === this.PERIMETER_USER_COUNT_STATUS_SOME_USERS) {
      if (this.isPerimeterUnSafe()) return '#aa0000';
      if (this.isPerimeterUnKnown()) return '#ffe600';
      if (this.isPerimeterSafe()) return '#00aa00';
    }
    return '#cccccc';
  }
  // Helper to get stroke color as hex string
  getStrokeColorHex() {
    if (this.perimeterUserCountStatus === this.PERIMETER_USER_COUNT_STATUS_SOME_USERS) {
      if (this.isPerimeterUnSafe()) return '#aa0000';
      if (this.isPerimeterUnKnown()) return '#ffe600';
      if (this.isPerimeterSafe()) return '#008800';
    }
    return '#000000';
  }
  // setMaterialFromStatus() {
  //   this.perimeterSafetyStatusLast = this.perimeterSafetyStatus;
  //   // Only update material if visible
  //   if (!this.isVirtualizedVisible) return;
  //   // For single entity, fallback to original material logic
  //   this.fallbackSetMaterial();
  // }

  // public resetSafetyStatusByStats(): void {
  //   // Clear the status
  //   this.perimeterSafetyStatus = this.PERIMETER_SAFETY_STATUS_SAFE;
  //   this.perimeterUserCountStatus = this.PERIMETER_USER_COUNT_STATUS_NO_USERS;

  //   // Force the status to be different so setMaterialFromStatus will execute
  //   this.perimeterSafetyStatusLast = 'FORCE_UPDATE';

  //   // Clear any existing datasource
  //   if (this.cesiumEntity && this.cesiumEntity.dataSource && this.coreService.getViewer()) {
  //     try {
  //       this.coreService.getViewer().dataSources.remove(this.cesiumEntity.dataSource);
  //       this.cesiumEntity.dataSource = undefined;
  //     } catch (error) {

  //     }
  //   }

  //   // Set to default material
  //   this.setMaterialFromStatus();
  // }

  public setSafetyStatusByStats(status: string): void {
    // Clear existing datasource first
    if (this.cesiumEntity && this.cesiumEntity.dataSource && this.coreService.getViewer()) {
      try {
        this.coreService.getViewer().dataSources.remove(this.cesiumEntity.dataSource);
        this.cesiumEntity.dataSource = undefined;
      } catch (error) {
      }
    }

    // Set new status
    if (status === 'unknown') {
      this.perimeterSafetyStatus = this.PERIMETER_SAFETY_STATUS_UNKNOWN;
    } else if (status === 'unsafe') {
      this.perimeterSafetyStatus = this.PERIMETER_SAFETY_STATUS_UNSAFE;
    } else if (status === 'safe') {
      this.perimeterSafetyStatus = this.PERIMETER_SAFETY_STATUS_SAFE;
    } else {
      this.perimeterSafetyStatus = this.PERIMETER_SAFETY_STATUS_SAFE;
    }

    this.perimeterUserCountStatus = this.PERIMETER_USER_COUNT_STATUS_SOME_USERS;

    // Force the status to be different so setMaterialFromStatus will execute
    this.perimeterSafetyStatusLast = 'FORCE_UPDATE';

    // this.setMaterialFromStatus();
  }
  public resetSafetyStatusByStats(perimeter: any): void {
    if (!perimeter?.id) return;
    let mesh = ThreeIntegrationService.roomMeshMap.get(perimeter.id);
    if (!mesh && perimeter.arcAngelId) {
      mesh = ThreeIntegrationService.roomMeshMap.get(perimeter.arcAngelId);
    }
    if (!mesh && typeof perimeter.id === 'string' && perimeter.id.startsWith('arc-angel-')) {
      mesh = ThreeIntegrationService.roomMeshMap.get(perimeter.id.replace('arc-angel-', ''));
    }
    if (!mesh) return;

    mesh.userData['perimeterSafetyStatus'] = this.PERIMETER_SAFETY_STATUS_SAFE;
    mesh.userData['perimeterUserCountStatus'] = this.PERIMETER_USER_COUNT_STATUS_NO_USERS;

    this.setMaterialFromStatus(perimeter);
  }
  public setMaterialFromStatus(perimeter: any): void {
    if (!perimeter?.id) return;
    let mesh = ThreeIntegrationService.roomMeshMap.get(perimeter.id);
    if (!mesh && perimeter.arcAngelId) {
      mesh = ThreeIntegrationService.roomMeshMap.get(perimeter.arcAngelId);
    }
    if (!mesh && typeof perimeter.id === 'string' && perimeter.id.startsWith('arc-angel-')) {
      mesh = ThreeIntegrationService.roomMeshMap.get(perimeter.id.replace('arc-angel-', ''));
    }
    if (!mesh) return;

    const safetyStatus = mesh.userData['perimeterSafetyStatus'];
    const userCountStatus = mesh.userData['perimeterUserCountStatus'];

    // Clean old sprite
    if (ThreeIntegrationService.statusIndicators.has(perimeter.id)) {
      const oldSprite = ThreeIntegrationService.statusIndicators.get(perimeter.id)!;
      oldSprite.parent?.remove(oldSprite);
      (oldSprite.material as THREE.Material).dispose();
      ThreeIntegrationService.statusIndicators.delete(perimeter.id);
    }

    if (userCountStatus === this.PERIMETER_USER_COUNT_STATUS_SOME_USERS) {
      let color = 0x808080;

      if (safetyStatus === this.PERIMETER_SAFETY_STATUS_UNSAFE) {
        color = 0xAA0000; // 170, 0, 0
      } else if (safetyStatus === this.PERIMETER_SAFETY_STATUS_UNKNOWN) {
        color = 0xFFE600; // 255, 230, 0
      } else if (safetyStatus === this.PERIMETER_SAFETY_STATUS_SAFE) {
        color = 0x008000; // 0, 128, 0
      }

      this.highlightRoom(mesh, color, 0.6);

      // Add sprite
      const texture = new THREE.TextureLoader().load(
        'assets/img/arcangel/user-status.svg'
      );

      const spriteMaterial = new THREE.SpriteMaterial({
        map: texture,
        color: color,
        transparent: true,
        depthTest: false,
        depthWrite: false
      });

      const sprite = new THREE.Sprite(spriteMaterial);
      sprite.scale.set(1.2, 1.2, 1);

      const box = new THREE.Box3().setFromObject(mesh);
      const centerWorld = box.getCenter(new THREE.Vector3());
      mesh.worldToLocal(centerWorld);

      sprite.position.copy(centerWorld);
      sprite.position.y += 0.2;

      mesh.add(sprite);
      ThreeIntegrationService.statusIndicators.set(perimeter.id, sprite);

    } else {
      this.resetRoomHighlight(mesh);
    }
  }
  private highlightRoom(
    roomMesh: THREE.Mesh,
    color: number,
    opacity = 0.35
  ): void {

    if (!roomMesh.userData['highlightMaterial']) {
      const baseMat = roomMesh.material as THREE.MeshPhongMaterial;
      const highlightMat = baseMat.clone();
      highlightMat.transparent = true;
      roomMesh.userData['highlightMaterial'] = highlightMat;
    }

    const mat = roomMesh.userData['highlightMaterial'] as THREE.MeshPhongMaterial;
    mat.color.setHex(color);
    mat.opacity = opacity;

    roomMesh.material = mat;

    const border = roomMesh.userData['border'] as THREE.LineSegments;
    if (border) {
      (border.material as THREE.LineBasicMaterial).color.setHex(color);
    }
  }
  private resetRoomHighlight(roomMesh: THREE.Mesh): void {

    if (roomMesh.userData['originalMaterial']) {
      roomMesh.material = roomMesh.userData['originalMaterial'];
    }

    const border = roomMesh.userData['border'] as THREE.LineSegments;
    if (border?.userData['originalColor']) {
      (border.material as THREE.LineBasicMaterial)
        .color.copy(border.userData['originalColor']);
    }
  }
  // Add this debug method to PerimeterMapEntityGeofance class
  debugRoomCoordinates(): void {
  }

  public setMaterialFromStatuss(): void {
    this.perimeterSafetyStatusLast = this.perimeterSafetyStatus;
    if (this.coreService.isIn3DMode()) {
      let material = Color.fromAlpha(Color.LIGHTGRAY, this.transparency);
      if (this.isPartOfBuilding) {
        if (this.perimeterUserCountStatus === PerimeterMapEntity.PERIMETER_USER_COUNT_STATUS_SOME_USERS) {
          if (this.isPerimeterUnSafe()) {
            material = Color.fromBytes(170, 0, 0, 255);
          } else if (this.isPerimeterUnKnown()) {
            material = Color.fromBytes(255, 230, 0, 255);
          } else if (this.isPerimeterSafe()) {
            material = Cesium.Color.fromBytes(0, 128, 0, 255);
          }
        }
        this.setMaterial(material);
      } else {
        this.setMaterial(material);
      }
    }
  }
  private fallbackSetMaterial() {
    // let material = Color.fromAlpha(Color.LIGHTGRAY, this.transparency);
    // if (this.isPartOfBuilding) {
    //   if (this.perimeterUserCountStatus === this.PERIMETER_USER_COUNT_STATUS_SOME_USERS) {
    //     if (this.isPerimeterUnSafe()) {
    //       material = Color.fromBytes(170, 0, 0, 255);
    //     } else if (this.isPerimeterUnKnown()) {
    //       material = Color.fromBytes(255, 230, 0, 255);
    //     }
    //   }
    //   this.setMaterial(material);
    // } else {
    //   this.setMaterial(material);
    // }
  }
}
class PerimeterAttribute extends BaseEntityAttribute {
  constructor(mapEntityId: string) {
    super(undefined, mapEntityId, false, false, undefined);
  }
}